import { render, staticRenderFns } from "./sponsorInfo.vue?vue&type=template&id=56254b3f&scoped=true&"
import script from "./sponsorInfo.vue?vue&type=script&lang=js&"
export * from "./sponsorInfo.vue?vue&type=script&lang=js&"
import style0 from "./sponsorInfo.vue?vue&type=style&index=0&id=56254b3f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56254b3f",
  null
  
)

export default component.exports